var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OUTPUT_ID, PARAMS_READY, READY } from './const';
function callCon(_a, params, connectorConfig) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, logger = _a.logger;
    if (params === void 0) { params = {}; }
    if (connectorConfig === void 0) { connectorConfig = {}; }
    var connector = data.connector, dynamicConfig = data.dynamicConfig;
    if (connector || dynamicConfig) {
        try {
            var finalConnector = connector;
            var finalOptions = { openMock: data.globalMock || data.mock, outputSchema: data.outputSchema, mockOutputId: data.mockOutputId };
            if (dynamicConfig) {
                finalConnector = dynamicConfig;
                finalOptions = { openMock: dynamicConfig.globalMock || data.mock, outputSchema: dynamicConfig.outputSchema, mockOutputId: dynamicConfig.mockOutputId };
            }
            env
                .callConnector(finalConnector, params, __assign(__assign(__assign({}, finalOptions), connectorConfig), { onResponseInterception: function (response) {
                    var _a;
                    (_a = outputs[OUTPUT_ID.HEADERS]) === null || _a === void 0 ? void 0 : _a.call(outputs, response.headers || {});
                }, isMultipleOutputs: true }))
                .then(function (val) {
                var _a, _b;
                outputs[(_a = val === null || val === void 0 ? void 0 : val.__OUTPUT_ID__) !== null && _a !== void 0 ? _a : 'then']((_b = val === null || val === void 0 ? void 0 : val.__ORIGIN_RESPONSE__) !== null && _b !== void 0 ? _b : val);
            })
                .catch(function (err) {
                outputs['catch'](err);
            });
        }
        catch (ex) {
            console.error(ex);
            outputs['catch']("\u6267\u884C\u9519\u8BEF ".concat(ex.message || ex));
            //onError(ex.message)
        }
    }
    else {
        outputs['catch']("\u6CA1\u6709\u9009\u62E9\u63A5\u53E3");
    }
}
function call(_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, params = _a.params, logger = _a.logger;
    if (data.callReady === READY) {
        data.callReady = PARAMS_READY;
        callCon({ env: env, data: data, outputs: outputs, logger: logger }, params, data.connectorConfig);
    }
}
export default function (_a) {
    var env = _a.env, data = _a.data, inputs = _a.inputs, outputs = _a.outputs, logger = _a.logger;
    var curParams;
    if (env.runtime) {
        if (data.immediate) {
            callCon({ env: env, data: data, outputs: outputs, logger: logger });
        }
        else {
            inputs['call'](function (params) {
                data.callReady |= data.useExternalUrl ? PARAMS_READY : READY;
                curParams = params;
                call({ env: env, data: data, logger: logger, params: typeof params === 'object' ? params : {}, outputs: outputs });
            });
        }
    }
}
